/**
 * Resolves the localised currency symbol for the given ISO currency code
 * using en-ZA (e.g. "R" for ZAR, "US$" for USD). en-GB renders ZAR as the
 * ISO code "ZAR" rather than "R", so en-ZA is used for symbol resolution
 * even though en-GB is used for number formatting.
 *
 * Returns the input currency code unchanged if the symbol cannot be resolved.
 */
export function resolveCurrencySymbol(currency) {
    const parts = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency,
    }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value ?? currency;
}
